import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "text-reader"
};
const _hoisted_2 = {
  key: 0,
  class: "loading"
};
const _hoisted_3 = {
  key: 1,
  class: "error"
};
const _hoisted_4 = {
  key: 2,
  class: "content"
};
import { ref, watch } from 'vue';
import { promiseTimeout } from '@vueuse/core';
export default /*@__PURE__*/_defineComponent({
  __name: 'TextReader',
  props: {
    url: {},
    delay: {}
  },
  setup(__props) {
    const props = __props;
    const textContent = ref('');
    const loading = ref(true);
    const error = ref('');
    const fetchTextContent = async () => {
      try {
        loading.value = true;
        error.value = '';
        const response = await fetch(props.url);
        if (!response.ok) {
          throw new Error('获取文本内容失败');
        }
        const blob = await response.blob();
        const reader = new FileReader();
        reader.readAsText(blob, 'UTF-8');
        const text = await new Promise(resolve => {
          reader.onload = () => resolve(reader.result);
        });
        textContent.value = text;
      } catch (e) {
        error.value = e instanceof Error ? e.message : '发生未知错误';
      } finally {
        loading.value = false;
      }
    };
    // 监听props.url变化
    watch(() => props.url, async newUrl => {
      if (newUrl) {
        if (props.delay) await promiseTimeout(props.delay);
        fetchTextContent();
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, "加载中...")) : error.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(error.value), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("pre", null, _toDisplayString(textContent.value), 1)]))]);
    };
  }
});